<template lang="pug">
  WtTile(parent :col=12 vertical)
    WtTitle(child).is-size-3.has-text-weight-light.stat-title Stats
    WtTile(horizontal :col=12 )
      WtTile.stat-tiles
        .column
          WtStatColumn(icon="purple-members" name="Members" :value="membersCount.toLocaleString()")
      WtTile.stat-tiles
        .column
          WtStatColumn(icon="blue-shoe" name="Total Steps" :value="totalSteps.toLocaleString()")
      WtTile.stat-tiles
        .column
          WtStatColumn(icon="red-line-graph" name="Average Steps" :value="averageSteps.toLocaleString()")
      WtTile.stat-tiles
        .column
          WtStatColumn(icon="blue-walk-man-icon" name="Total Activities" :value="totalActivities.toLocaleString()")
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtStatColumn from "@@/WtStatColumn/WtStatColumn";

export default {
  name: "OrganizationStats",

  components: {
    WtTitle,
    WtTile,
    WtStatColumn
  },

  props: {
    totalSteps: {
      type: Number,
      default: 0
    },
    totalActivities: {
      type: Number,
      default: 0
    },
    membersCount: {
      type: Number,
      default: 0
    }
  },

  computed: {
    averageSteps() {
      return this.membersCount > 0
        ? parseInt(this.totalSteps / this.membersCount)
        : 0;
    },
    averageActivities() {
      return this.membersCount > 0
        ? parseInt(this.totalActivities / this.membersCount)
        : 0;
    }
  }
};
</script>

<style lang="sass" scoped>
.full-height
  height: 100%
.stat-tiles
  background-color: $white
  border-radius: 12px
  margin-right: 12px
.stat-title
  font-family: Manrope
</style>
